import React from 'react';
import { find, times } from 'lodash';
import { defaultCount, defaultSize, sizeList } from 'sharedParts/config/blockConfig/questionNumeric';
import personalLabelMap from 'sharedParts/config/personalLabelMap';
import { highlightColorsList } from 'sharedParts/config/blockConfig/questionScale';
const fillColor = '#000';

export default ({
  length = defaultCount,
  labelType,
  startFromZero = false,
  size = defaultSize,
  empty = {},
  full = {},
  e2e,
  iconTextClassName = '',
}) => {
  const iconSize = find(sizeList, { value: size }).size;
  const emptyIconStyle = {
    fontSize: `${iconSize}px`,
  };
  const indexes = times(length);

  if (labelType === personalLabelMap.numberDesc) {
    indexes.reverse();
  }

  const renderIconList = ({ props, isFull }) => {
    const count = indexes.length;
    const fullIconStyle = highlightColorsList[count];

    return indexes.map((item, index) => {
      const style = isFull
        ? {
            color: fillColor,
            ...emptyIconStyle,
            ...fullIconStyle[index],
          }
        : emptyIconStyle;

      return (
        <div {...props}>
          <span data-e2e={e2e} className={iconTextClassName} style={style}>
            {startFromZero ? item : item + 1}
          </span>
        </div>
      );
    });
  };

  return {
    empty: renderIconList({ props: empty, isFull: false }),
    full: renderIconList({ props: full, isFull: true }),
  };
};
